// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomScrollbar_wrapper__PQKGj","track":"CustomScrollbar_track__3WTA1","thumb":"CustomScrollbar_thumb__fmJJy"};